var exports = {
  "kL": "ReportFlowSummary.module__container___ajY5OD",
  "ed": "ReportFlowSummary.module__disclaimer___ajY5OD",
  "uW": "ReportFlowSummary.module__section___ajY5OD",
  "R_": "ReportFlowSummary.module__heading___ajY5OD",
  "GA": "ReportFlowSummary.module__answers___ajY5OD",
  "ZF": "ReportFlowSummary.module__answer___ajY5OD",
  "yy": "ReportFlowSummary.module__answerText___ajY5OD",
};

module.exports = exports;
